import {
    REQUEST_BILLINGS,
    REQUEST_BILLINGS_FAILURE,
    REQUEST_BILLINGS_SUCCESS
} from "../../../constant/transaction/BillingConstant";

const initialState = {
    billings: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const billingsReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_BILLINGS:
            return {
                ...state,
                billings: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_BILLINGS_SUCCESS:
            return {
                ...state,
                billings: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_BILLINGS_FAILURE:
            return {
                ...state,
                billings: {
                    data: [],
                    status: 'fetching',
                },
            };
        default:
            return state;
    }
}
